<template>
    <div class="footer-bottom">
        <div class="footer-bottom--row grid--row">
            <div class="footer-bottom--left grid--col">
                <footer>
                    <small>
                        {{ title }}
                    </small>
                </footer>
            </div>
            <div class="footer-bottom--right grid--col">
                <h2 class="footer-bottom--title u-reset">{{ addressTitle }}</h2>
                <p class="footer-bottom--paragraph" v-html="address"/>
                <nav class="footer-bottom--links">
                    <ul class="footer-bottom--collection u-reset">
                        <li class="footer-bottom--item" v-for="(link, index) in links" :key="index">
                            <conditional-link class="link-list--link u-reset" v-bind="link">
                                {{ link.label }}
                            </conditional-link>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
    import ConditionalLink from 'framework/components/conditional-link/conditional-link';

    export default {
        components: {
            ConditionalLink,
        },
        props: {
            address: {
                type: String,
                required: true,
            },
            addressTitle: {
                type: String,
                required: true,
            },
            title: {
                type: String,
                required: true,
            },
            /** @type {ILinks} */
            links: {
                type: Array,
                required: true,
            },
        },
    };
</script>
